interface ExpandableContentProps {
    value: string;
    shortLenth: number;
    onShowMore: (content: string) => void;
}

export const ExpandableContent: React.FC<ExpandableContentProps> = ({
    value,
    onShowMore,
    shortLenth
}) => (
    <>
        {value.slice(0, shortLenth)}
        <span
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() => onShowMore(value)}
        >
            ...(Mehr anzeigen)
        </span>
    </>
);
